module.exports = __webpack_public_path__ + "img/bg3.84061a28.png";